import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ChatsQueryKeys } from "./chatsQueryKeys";
import { getChatsPaginated, GetChatsPaginatedParams } from "@/api/chats";

export const useChatsPaginated = (
  params?: GetChatsPaginatedParams,
  options: { enabled?: boolean } = {}
) => {
  return useQuery({
    queryKey: [ChatsQueryKeys.ChatsPaginated, params],
    enabled: options.enabled ?? true,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) =>
      getChatsPaginated({ signal, params: params || {} }),
  });
};
